import React from "react"

import { Flex, Typography } from "antd"
import cls from "classnames"

import Icon from "../../../../../Icon"

import "./EnrollmentTabs.less"

const { Text } = Typography

const EnrollmentTabs = ({ options, value, onChange, className, variant = "user", ...props }) => {
  return (
    <Flex
      className={cls("enrollment-tabs", `enrollment-tabs-${variant}`, className)}
      gap={4}
      {...props}
    >
      {options.map((option) => {
        const isActive = value === option.value
        return (
          <button
            key={option.value}
            type="button"
            disabled={option.disabled}
            className={cls("tab", { active: isActive, disabled: option.disabled })}
            onClick={() => !option.disabled && onChange?.(option.value)}
          >
            {option?.icon && <Icon type={option.icon} className="icon" />}

            <Text
              type={isActive ? "" : "secondary"}
              strong={variant === "user"}
              disabled={option.disabled}
            >
              {option.label}
            </Text>
          </button>
        )
      })}
    </Flex>
  )
}

export default EnrollmentTabs
